import React from 'react';
import useTheme from 'branding/theme';
import useSubtheme from '../../hooks/useSubtheme';
import useSectionPadding from '../../hooks/useSectionPadding';
import useSectionMargin from '../../hooks/useSectionMargin';
const Section = ({ role = 'section', subtheme = ['regular', 'transparent'], centered = false, centeredHorizontally = false, centeredVertically = false, centeredText = false, width, children, styles, className, id, border = false, borderBottom = false, noDefaultPadding, padding = 'regular', paddingHorizontal, paddingVertical, paddingTop, paddingBottom, paddingLeft, paddingRight, margin, marginHorizontal, marginVertical, marginTop, marginBottom, marginLeft, marginRight }) => {
    const Tag = role === 'wrapper' ? 'div' : role;
    const { borders, sizing } = useTheme();
    const subthemeStyles = useSubtheme(subtheme);
    const paddingStyles = useSectionPadding({
        padding: noDefaultPadding ? undefined : padding,
        paddingHorizontal,
        paddingVertical,
        paddingTop,
        paddingBottom,
        paddingLeft,
        paddingRight
    });
    const marginStyles = useSectionMargin({
        margin,
        marginHorizontal,
        marginVertical,
        marginTop,
        marginBottom,
        marginLeft,
        marginRight
    });
    const centerStyles = {
        display: 'flex',
        flexDirection: 'column',
        ...((centered || centeredHorizontally || centeredText) && { alignItems: 'center' }),
        ...((centered || centeredVertically) && { justifyContent: 'center' }),
        ...(centeredText && { textAlign: 'center' })
    };
    const mergedStyles = {
        ...subthemeStyles,
        ...marginStyles,
        ...(role !== 'wrapper' ? paddingStyles : { flexGrow: 1 }),
        ...(border && borders.base),
        ...(borderBottom && borders.bottom),
        ...(role !== 'wrapper' && borders.shape.veryRounded),
        ...((centered || centeredText || centeredHorizontally || centeredVertically) &&
            centerStyles),
        ...(width && sizing.widths.layout[width]),
        boxSizing: 'border-box',
        ...styles
    };
    return (React.createElement(Tag, { style: mergedStyles, className: className, id: id }, children));
};
export default Section;
//# sourceMappingURL=index.js.map